export const BASE_URL = "https://proludo.net";
export const STRIPE_PUBLIC_KEY = "pk_live_5bvW5jzNXsPTbGJtKt7iqpeu00VIUydq1y";
